var _ellipse, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDuurzaamIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 277,
    height: 210,
    viewBox: "0 0 277 210",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.7,
    cx: 138.5,
    cy: 195.313,
    rx: 138.5,
    ry: 14.5,
    fill: "#EAF2F6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M115.419 136.82C115.127 136.82 114.834 136.82 114.509 136.722C93.8546 132.886 70.8912 118.449 68.224 89.4466C66.6953 72.7017 73.6233 56.7372 88.8131 42.0082C89.1709 41.6505 89.4636 41.3904 89.6588 41.1953C91.0248 39.3095 93.5944 38.6592 95.7737 39.7322C98.1806 40.9352 99.1564 43.8615 97.9529 46.2676C97.4976 47.2105 96.9121 47.7632 95.611 49.0313C90.7646 53.7133 76.0628 67.9871 77.9493 88.5687C80.649 118.254 107.971 125.603 116.298 127.163C118.932 127.651 120.689 130.22 120.201 132.853C119.778 135.194 117.729 136.853 115.419 136.853V136.82Z",
    fill: "#334B6E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M75.412 159.157C73.3303 159.157 71.4113 157.824 70.7607 155.743C69.9476 153.175 71.3787 150.444 73.9483 149.631C139.196 129.179 155.361 59.8586 155.524 59.1758C156.109 56.5421 158.711 54.8839 161.346 55.4692C163.981 56.0544 165.64 58.6556 165.054 61.2892C164.371 64.3456 147.588 136.788 76.8757 158.93C76.3878 159.092 75.8999 159.157 75.412 159.157Z",
    fill: "#F7A821"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M153.865 151.256C144.075 151.256 134.577 148.493 127.389 143.16C125.21 141.567 124.787 138.511 126.381 136.332C127.974 134.154 131.032 133.731 133.211 135.324C142.709 142.38 157.606 143.55 170.258 138.251C186.034 131.618 196.377 115.978 199.337 94.2587C204.443 56.8347 187.302 31.8312 178.097 18.3703C172.178 9.72146 169.836 8.35585 156.337 11.9649C140.595 15.5415 111.484 31.5061 111.191 31.6686C108.817 32.9692 105.857 32.1238 104.556 29.7503C103.255 27.3767 104.1 24.4179 106.475 23.1174C107.711 22.4346 137.082 6.30745 153.963 2.50327C170.551 -1.95119 177.512 0.259783 186.131 12.8428C195.369 26.3363 214.592 54.4287 208.997 95.5593C204.346 129.667 185.09 142.575 174.032 147.225C167.591 149.923 160.663 151.256 153.865 151.256Z",
    fill: "#334B6E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDuurzaamIcon);
export default __webpack_public_path__ + "static/media/duurzaam_icon.63c0ca6f58de0c7d146a75b9c186ad7f.svg";
export { ForwardRef as ReactComponent };